"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseColumnNamesToColumnPresetData = void 0;
var i18n_1 = __importDefault(require("Shared/plugins/i18n"));
var parseColumnNamesToColumnPresetData = function (columns, type) {
    var presetColumns = columns.reduce(function (acc, item, index) {
        return __spreadArray(__spreadArray([], acc, true), [
            {
                name: item,
                active: true,
                order: index,
            },
        ], false);
    }, []);
    return {
        name: i18n_1.default.t("default"),
        id: 0,
        columns: presetColumns,
        type: type,
        created_at: "",
        updated_at: "",
        provider_id: 0,
    };
};
exports.parseColumnNamesToColumnPresetData = parseColumnNamesToColumnPresetData;
